export default {
  firebase: {
  //   apiKey: "AIzaSyCD4ySsxCO4ImxAHXljyFsvtXAer6xjlsg",
  // authDomain: "freecodingschool-lu.firebaseapp.com",
  // databaseURL: "https://freecodingschool-lu.firebaseio.com",
  // projectId: "freecodingschool-lu",
  // storageBucket: "freecodingschool-lu.appspot.com",
  // messagingSenderId: "168655958584",
  // appId: "1:168655958584:web:e3a9b996c453caa2d7accd",
  // measurementId: "G-S125LY391F"
  "apiKey": "AIzaSyDNv4Yu4gvlvikZU123Wn9zlkBswy141PI",
    "authDomain": "egp1-8b9a7.firebaseapp.com",
    "databaseURL": "https://egp1-8b9a7.firebaseio.com",
    "projectId": "egp1-8b9a7",
    "storageBucket": "egp1-8b9a7.appspot.com",
    "messagingSenderId": "900250843552",
    "appId": "1:900250843552:web:e6af6dd2a88e19d6c94cc5",
    "measurementId": "G-1X15J8HQZC"
  }
}



// WEBPACK FOOTER //
// ./src/env.staging.js